import axios from "axios";
import {
  ip
} from "./config";
import {
  getUrlParams
} from "@/utils/getUrlParams.js";
import {
  loginUrl,
  appid
} from "../../config/index";
// import {
//   Toast
// } from "vant";
import {
  Dialog
} from "vant";

// 根据动态code登录获取用户信息------TODO: 为啥每用一次登录code过期-----------------------
export async function login(code) {
  var resp = await axios.post(`${ip}/zskx/h5/login`, {
    code,
  });
  return resp.data;
}

// 根据openid登录获取用户信息-----------------------------
export async function selectOpenid(openid) {
  var resp = await axios.post(`${ip}/zskx/h5/selectOpenid`, {
    openid,
  });
  return resp.data;
}

/* 根据手机号判断该用户是不是新用户 */
export async function selectPhone(data) {
  var resp = await axios.post(`${ip}/zskx/h5/selectPhone`, {
    ...data,
  });
  return resp.data;
}

// 绑定手机号-----------------------------
export async function setPhone(data) {
  var resp = await axios.post(`${ip}/zskx/h5/setPhone`, {
    ...data,
  });
  return resp.data;
}

//判断是否更换手机号成功的方法
async function setPhoneFun({
  openid,
  phone
}) {
  console.log('phone==========================', phone)
  if (/^1[23456789]\d{9}$/.test(phone)) {
    const result = await setPhone({
      openid,
      phone
    });
    if (result.code === 200) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

/* 获取用户登录code */
export async function useWxCode() {

  const localCode = localStorage.getItem('code')
  const localPhone = localStorage.getItem('phone')
  const localOpenid = localStorage.getItem('openid')

  const urlPhone = getUrlParams(window.location.href)?.phone;
  const urlCode = getUrlParams(window.location.href)?.code;

  const uri = encodeURIComponent(loginUrl);
  const authURL = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_base&state=${urlPhone}&timestamp=${new Date().getTime()}#wechat_redirect`; //静默授权
  // console.log('authURL======================', authURL)
  // console.log('localCode==========', localCode, urlCode)
  // console.log('localOpenid=================', localOpenid)

  if (localOpenid) {
    let userInfo = await selectOpenid(localOpenid);
    // console.log('localOpenid-userInfo', userInfo)
    if (userInfo.code === 200) {
      let isPhone =await setPhoneFun({
        openid: localOpenid,
        phone: urlPhone
      })
      // console.log('isPhone======================', isPhone, urlPhone)
      if (isPhone) {
        userInfo.data.phone = urlPhone
      }
      return userInfo || {}
    }
  }

  if (localCode) {
    let userInfo = await login(localCode);
    // console.log('localCode-userInfo', userInfo)
    if (userInfo.code === 200) {
      let isPhone =await setPhoneFun({
        openid: userInfo.data.openid,
        phone: localPhone
      })
      // console.log('isPhone======================', isPhone, localPhone)
      if (isPhone) {
        userInfo.data.phone = localStorage.getItem('phone')
      }
      localStorage.setItem('openid', userInfo.data.openid);
      return userInfo || {}
    }

    Dialog.confirm({
        title: `登录`,
        message: "当前登录已过期，是否重新登录？",
        theme: "round-button",
        showCancelButton: false,
        confirmButtonText: "确定",
      })
      .then(() => {
        // on confirm
        console.log("用户点击了确认");
        localStorage.setItem('code', '');
        localStorage.setItem('openid', '');
        window.location.href = authURL
      })
      .catch(() => {
        // on cancel
        console.log("用户点击了取消");
      });
    return
  }


  if (!urlCode && !localCode) {
    window.location.href = authURL
  }

}

/* 以下废弃============================================================================== */

// 腾讯授权登录 成功返回拥有code的链接URL
// export function getAuthURL({
//   phone,
//   redirect
// }) {
//   let redirectUrl = redirect === 'prizeUrl' ? prizeUrl :
//     redirect === 'addGzhUrl' ? addGzhUrl :
//     redirect === 'selectGzhUserUrl' ? selectGzhUserUrl :
//     customerUrl
//   const uri = encodeURIComponent(redirectUrl); //phone ? navageteToUrl : navageteToIndex
//   // let authURL = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=success#wechat_redirect`; //非静默授权
//   const authURL = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_base&state=${phone}#wechat_redirect`; //静默授权
//   return authURL;
// }

// 取链接中的code
// function getUrlParam(name) {
//   let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
//   let r = window.location.search.substr(1).match(reg);
//   if (r != null) {
//     return unescape(r[2]);
//   }
//   return null;
// }
// 设置cookie
// function setCookie(c_name, value, expiredays) {
//   var exdate = new Date();
//   exdate.setDate(exdate.getDate() + expiredays);
//   document.cookie =
//     c_name +
//     "=" +
//     escape(value) +
//     (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
//   console.log("设置成功");
// }

//取回cookie
// function getCookie(c_name) {
//   if (document.cookie.length > 0) {
//     let c_start = document.cookie.indexOf(c_name + "=");
//     if (c_start != -1) {
//       c_start = c_start + c_name.length + 1;
//       let c_end = document.cookie.indexOf(";", c_start);
//       if (c_end == -1) c_end = document.cookie.length;
//       return unescape(document.cookie.substring(c_start, c_end));
//     }
//   }
//   return "";
// }

// 判断是否为公众号模拟器环境
// isWechat() {
//   var result =
//     String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
//     "micromessenger";
//   return result;
// },